import ActionTypes from "../constants/ActionTypes";

const initialState = {
    isFetching: true,
    isUpdating: false,
    isOktaFetching: false,
    isOktaUser: false,
    loggedIn: false,
    profile: {},
    nonce: null as any,
};

export default function userReducer(state = initialState, action: any = {}) {
    switch (action.type) {
        case ActionTypes.AUTHENTICATED:
            return {
                ...state,
                loggedIn: true,
                // nonce: action.nonce,
            };
        case ActionTypes.SET_USER_NONCE:
            return {
                ...state,
                nonce: action.nonce,
            };
        // case ActionTypes.REGISTER_SUCCESS:
        //     return action.profile;
        // case ActionTypes.LOGIN_SUCCESS:
        //     return action.profile;
        case ActionTypes.OKTA_REDIRECT_REQUEST:
            return {
                ...state,
                isOktaFetching: true,
            };
        case ActionTypes.OKTA_REDIRECT_FAILURE:
            return {
                ...state,
                isOktaFetching: false,
            };
        case ActionTypes.OKTA_REDIRECT_SUCCESS:
            return {
                ...state,
                isOktaFetching: false,
            };
        case ActionTypes.SET_LOGIN_CALLBACK:
            return {
                ...state,
                loginCallback: action.loginCallback,
            };
        case ActionTypes.CLEAR_LOGIN_CALLBACK:
            return {
                ...state,
                loginCallback: null,
            };
        case ActionTypes.LOGOUT:
            return initialState;
        case ActionTypes.GET_PROFILE_REQUEST:
            return {
                ...state,
                isFetching: true,
            };
        case ActionTypes.GET_PROFILE_FAIL:
            return {
                ...initialState,
                nonce: state.nonce,
            };
        case ActionTypes.GET_PROFILE_SUCCESS:
            const isOktaUser =
                action.profile.type &&
                action.profile.type !== "public" &&
                action.profile.type !== "alumni";
            return {
                ...state,
                profile: action.profile,
                isOktaUser: isOktaUser,
                isFetching: false,
            };
        case ActionTypes.UPDATE_PROFILE_REQUEST:
            return {
                ...state,
                isUpdating: true,
            };
        case ActionTypes.UPDATE_PROFILE_FAIL:
            return {
                ...state,
                isUpdating: false,
            };
        case ActionTypes.UPDATE_PROFILE_SUCCESS:
            return {
                ...state,
                isUpdating: false,
                profile: { ...state.profile, ...action.profile },
            };
        case ActionTypes.GET_MY_OPTIN_SUCCESS:
            return {
                ...state,
                optIns: action.optIns,
            };
        case ActionTypes.GET_PURCHASED_EVENTS_SUCCESS:
            return {
                ...state,
                purchasedEvents: action.purchasedEvents,
            };
        case ActionTypes.GET_MY_MEMBERSHIPS_REQUEST:
            return {
                ...state,
                isFetching: true,
            };
        case ActionTypes.GET_MY_MEMBERSHIPS_FAIL:
            return {
                ...state,
                isFetching: false,
            };
        case ActionTypes.GET_MY_MEMBERSHIPS_SUCCESS:
            return {
                ...state,
                memberships: action.memberships,
                isFetching: false,
            };
        default:
            return state;
    }
}
